// @ts-nocheck

import { UserActionTypes } from '../../../types/actions/user';
import createReducer from '../../../utils/createReducer';
import { HistoryFilters } from '../types';
import type { HistoryState } from '../types';
import { GridsActionTypes } from '../types/actions';
import type {
  SetHistoryGridCountAction,
  SetHistoryFetchingAction,
  SetHistoryPageAction,
  SetHistoryFilterAction,
  SetHistoryReferencesAction,
} from '../types/actions';

export const initialState: HistoryState = {
  gridCount: null,
  isFetching: false,
  currentPage: 0,
  filter: HistoryFilters.ALL,
  gridReferences: [],
};

export const setHistoryGridCount = (state: HistoryState, action: SetHistoryGridCountAction): HistoryState => {
  const { gridCount } = action.payload;
  return {
    ...state,
    gridCount,
    isFetching: false,
  };
};

export const setHistoryFetching = (state: HistoryState, action: SetHistoryFetchingAction): HistoryState => {
  const { isFetching } = action.payload;
  return {
    ...state,
    isFetching,
  };
};

export const setHistoryPage = (state: HistoryState, action: SetHistoryPageAction): HistoryState => {
  const { currentPage: actionCurrentPage } = action.payload;
  const { currentPage: storeCurrentPage } = state;
  if (storeCurrentPage !== actionCurrentPage) {
    return {
      ...state,
      currentPage: actionCurrentPage,
    };
  }
  return state;
};

export const setHistoryFilter = (state: HistoryState, action: SetHistoryFilterAction): HistoryState => {
  const { filter: actionCurrentFilter } = action.payload;
  const { filter: stateCurrentFilter } = state;
  if (stateCurrentFilter !== actionCurrentFilter) {
    return {
      ...state,
      filter: actionCurrentFilter,
      currentPage: 0,
    };
  }
  return state;
};

export const askHistoryGrids = (state: HistoryState): HistoryState => {
  return {
    ...state,
    isFetching: true,
  };
};

export const setHistoryReferences = (state: HistoryState, action: SetHistoryReferencesAction): HistoryState => {
  const { gridReferences } = action.payload;
  return {
    ...state,
    gridReferences,
  };
};

export const resetHistory = (): HistoryState => {
  return initialState;
};

export default createReducer(initialState, {
  [UserActionTypes.SET_DISCONNECTED]: resetHistory,
  [GridsActionTypes.SET_HISTORY_GRID_COUNT]: setHistoryGridCount,
  [GridsActionTypes.SET_HISTORY_FETCHING]: setHistoryFetching,
  [GridsActionTypes.SET_HISTORY_PAGE]: setHistoryPage,
  [GridsActionTypes.SET_HISTORY_FILTER]: setHistoryFilter,
  [GridsActionTypes.ASK_HISTORY_GRIDS]: askHistoryGrids,
  [GridsActionTypes.SET_HISTORY_REFERENCES]: setHistoryReferences,
});
